/*
 * @Author: Czy
 * @Date: 2024-08-20 15:30:49
 * @FilePath: /crowdsource-wechat/src/utils/dict.ts
 *
 */
// import request from './request'
import { http } from '@/utils/http'

import { ref, watch, Ref } from 'vue'

export interface Dict<T = any> {
  type: string
  value: string
  label: string
  dictDataId: string
  dictSort?: number
  dictLabel: string
  dictValue: string
  dictType: string
  cssClass?: string
  listClass?: string
  isDefault?: 'Y' | 'N'
  status: string
  business?: T
  remark?: string
}
export interface DictStore<T = any> {
  [key: string]: Dict<T>[]
}

const dictStore = ref<DictStore<any>>(JSON.parse(uni.getStorageSync('dict') || '{}'))

watch(dictStore, (value) => {
  uni.setStorageSync('dict', JSON.stringify(value))
})

const dictLoading = ref<{ [key: string]: boolean }>({})

const useDict = <T = string>(...args: string[]): Ref<DictStore<T>> => {
  const getDicts = (dictType: string) => {
    return http.get(`/app/infra/platform/dict/data/type/${dictType}`, {})
  }
  args.forEach((dictType) => {
    if (!dictStore.value[dictType] && !dictLoading.value[dictType]) {
      dictStore.value[dictType] = []
      dictLoading.value[dictType] = true
      getDicts(dictType)
        .then((result: PageResult<Dict>) => {
          dictStore.value = {
            ...dictStore.value,
            [dictType]: result.rows.map((item) => {
              let business: any = item.business
              if (typeof item.business === 'string') {
                try {
                  business = JSON.parse(item.business)
                } catch (error) {}
              }
              return {
                ...item,
                label: item.dictLabel,
                value: item.dictValue,
                type: item.type,
                business,
              }
            }),
          }
        })
        .catch(() => {
          dictStore.value[dictType] = undefined
        })
        .finally(() => {
          dictLoading.value[dictType] = false
        })
    }
  })
  return dictStore
}

export default useDict
